import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Filtro } from "../paginas/paginas-setoriais/setor/noticias/noticias.component";
import { ApiConfig, Path, SiteAdmApiConfig } from "../util/path";
import { Noticia } from "../modelos/noticia";
import {DatePipe} from '@angular/common';
import {ResponsePageable} from "../modelos/ResponsePageable";

@Injectable({
    providedIn: 'root'
})
export class NoticiaService {
    private token: String;
    constructor(private httpClient: HttpClient) {
      this.token = ApiConfig.API_TOKEN;
    }

    private getCabecalho() {
        let cabecalho = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
          })
        };
        return cabecalho;
      }

    getNoticias(antigo: boolean, busca: string, pagina: number, qtd: number): Observable<ResponsePageable>{
        let url = SiteAdmApiConfig.API_URL + Path.IMPRENSA.nomeService +
            `/v1/external/noticia/listarPaginado?pagina=${pagina}&busca=${busca}&linhasPorPagina=${qtd}` + `&dataFim=${new DatePipe('en-US').transform(new Date(), 'YYYY-MM-dd')?.substring(0,10)}`;
        return this.httpClient.get<ResponsePageable>(url, this.getCabecalho());
    }

    public getEstatisticasUnidade( pagina: number | undefined, quantidade: number | undefined, idUnidade: number, filtro: Filtro): Observable<Noticia> {

      let url = SiteAdmApiConfig.API_URL + `${Path.IMPRENSA.nomeService}/v1/external/noticia/${Path.LISTAR_PAGINADO.caminho}pagina=${pagina}&linhasPorPagina=${quantidade}`;

      if (filtro.filtroDataInicio) {
        url += `&dataInicio=${filtro.filtroDataInicio.toISOString().substring(0,10)}`;
      }

      // Ajuste necessário para fazer com que a busca por notícias seja feita apenas até a data de hoje, evitando capturar notícias agendadas
      if (filtro.filtroDataFim) {
          let dataFiltro = new Date(filtro.filtroDataFim);
          filtro.filtroDataFim = dataFiltro.getTime() <= Date.now() ?
              filtro.filtroDataFim.toISOString().substring(0,10) : new DatePipe('en-US').transform(new Date(), 'YYYY-MM-dd')?.substring(0,10) ;
          url += `&dataFim=${filtro.filtroDataFim}`;
      } else{
          url += `&dataFim=${new DatePipe('en-US').transform(new Date(), 'YYYY-MM-dd')?.substring(0,10)}`;
      }

      if (filtro.filtroBusca) {
        url += `&busca=${filtro.filtroBusca}`;
      }

      if (idUnidade) {
        url += `&idUnidadeJurisdicional=${idUnidade}`;
      }

      if (filtro.filtroCategoria) {
        url += '&categoria=';

        url += this.tipoCategoria(filtro.filtroCategoria);
    }

      return this.httpClient.get<Noticia>(url, this.getCabecalho());
    }

    public getNoticiasSlideshow( pagina: number | undefined, quantidade: number | undefined): Observable<Noticia> {

        let url = SiteAdmApiConfig.API_URL +
        `${Path.IMPRENSA.nomeService}/v1/external/noticia/${Path.LISTAR_PAGINADO.caminho}pagina=${pagina}&linhasPorPagina=${quantidade}` +
        `&dataFim=2024-10-09`;

        url += '&categoria=SLIDESHOW';


        return this.httpClient.get<Noticia>(url, this.getCabecalho());
      }

    public getNoticiasPaginaInicial( pagina: number | undefined, quantidade: number | undefined): Observable<Noticia> {

      let url = SiteAdmApiConfig.API_URL +
        `${Path.IMPRENSA.nomeService}/v1/external/noticia/${Path.LISTAR_PAGINADO.caminho}pagina=${pagina}&linhasPorPagina=${quantidade}` +
          `&dataFim=${new DatePipe('en-US').transform(new Date(), 'yyyy-MM-dd')?.substring(0,10)}`;

        url += '&categoria=PAGINA_INICIAL';

      return this.httpClient.get<Noticia>(url, this.getCabecalho());
    }

    public getNoticiasPaginaAcessilidade( pagina: number | undefined, quantidade: number | undefined): Observable<Noticia> {

      let url = SiteAdmApiConfig.API_URL +
        `${Path.IMPRENSA.nomeService}/v1/external/noticia/${Path.LISTAR_PAGINADO.caminho}pagina=${pagina}&linhasPorPagina=${quantidade}` +
          `&dataFim=${new DatePipe('en-US').transform(new Date(), 'YYYY-MM-dd')?.substring(0,10)}`;

        url += '&categoria=ACESSIBILIDADE';

      return this.httpClient.get<Noticia>(url, this.getCabecalho());
    }

  public getNoticiasPaginaCejure( pagina: number | undefined, quantidade: number | undefined): Observable<Noticia> {

    let url = SiteAdmApiConfig.API_URL +
      `${Path.IMPRENSA.nomeService}/v1/external/noticia/${Path.LISTAR_PAGINADO.caminho}pagina=${pagina}&linhasPorPagina=${quantidade}` +
      `&dataFim=${new DatePipe('en-US').transform(new Date(), 'YYYY-MM-dd')?.substring(0,10)}`;

    url += '&categoria=CEJURE';

    return this.httpClient.get<Noticia>(url, this.getCabecalho());
  }

    getNoticiasPorIds(stringIds: number[]): Observable<Noticia[]>{
        const url = SiteAdmApiConfig.API_URL +
        `${Path.IMPRENSA.nomeService}/v1/external/noticia/list/${stringIds}`

        return this.httpClient.get<Noticia[]>(url, this.getCabecalho());
    }



    public getNoticia( id: string): Observable<Noticia> {
      let url = SiteAdmApiConfig.API_URL +
      `${Path.IMPRENSA.nomeService}/v1/external/noticia/${id}`;
      return this.httpClient.get<Noticia>(url, this.getCabecalho());

    }

    tipoCategoria(tipoCategoria : string): string | void {
      if(tipoCategoria == 'Acessibilidade'){
          return 'ACESSIBILIDADE';
      }

      if(tipoCategoria == 'Inovação'){
          return 'INOVACAO';
      }

      if(tipoCategoria == 'Sustentabilidade'){
          return 'SUSTENTABILIDADE';
      }

  }
}
